import PropTypes from 'prop-types';
export var ClientPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  directoryName: PropTypes.string.isRequired,
  altName: PropTypes.string.isRequired,
  logo: PropTypes.string
});
export var LotPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  inventory: PropTypes.shape({
    schemeId: PropTypes.number
  })
});
export var SchemeMaterialPropType = PropTypes.shape({
  hex: PropTypes.string,
  id: PropTypes.number.isRequired,
  material: PropTypes.string.isRequired,
  materialCategory: PropTypes.string.isRequired,
  materialId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  masonryLib: PropTypes.bool,
  swatch: PropTypes.string
});
export var SchemePropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  materials: PropTypes.arrayOf(SchemeMaterialPropType)
});
export var ColorPropType = PropTypes.shape({
  masonryLib: PropTypes.bool,
  swatch: PropTypes.string,
  hex: PropTypes.string
});
export var ColorSelectionPropType = ColorPropType;
export var PalettePropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  selections: PropTypes.arrayOf(ColorPropType).isRequired
});
export var MaterialPalettePropType = PropTypes.shape({
  materialCategory: PropTypes.string.isRequired,
  materialId: PropTypes.number.isRequired,
  palettes: PropTypes.arrayOf(PalettePropType).isRequired
});
export var LayerPropType = PropTypes.shape({
  materialId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired
});
export var ElevationPropType = PropTypes.shape({
  base: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  layers: PropTypes.arrayOf(LayerPropType),
  materialPalettes: PropTypes.arrayOf(MaterialPalettePropType),
  schemes: PropTypes.arrayOf(SchemePropType)
});